
export const tabsTheme = {
	variants: {
		primary: {
			tablist: {
				borderBottom: "1px solid",
				borderColor: "gray.200",
			},
			tab: {
				color: "gray.500",
				fontWeight: "semibold",
				borderBottom: "2px solid transparent",
				mb: "-1px",
				_selected: {
					color: "black",
					borderBottom: "2px solid limegreen",
				},
			},
		},
	},
};
